export default "__VITE_ASSET__BQ7hTY4O__"